import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UtilityMenu } from 'components/UtilityMenu';
import { getMachine } from 'lib/selectors/getMachine';
import { CategorizeDowntime } from './CategorizeDowntime';
import { ControlBarResponsive, SingleButtonScrollable } from '../styled';

/**
 * Control bar component for active job in ERP-driven mode.
 *
 * This component is rendered when:
 * - Operator is signed in
 * - Job is currently running
 * - System is in ERP-driven mode
 *
 * In ERP-driven mode, job control is managed by the ERP system.
 * The operator can only categorize downtime; all other job actions
 * (submit, pause, resume, switch activity, sign out) are handled
 * automatically by the ERP integration.
 *
 * @returns {JSX.Element} Control bar with only downtime categorization option
 */
const ActiveJobErpDriven = () => {
  const history = useHistory();
  const machine = useSelector(getMachine);

  return (
    <ControlBarResponsive id="job-control-bar">
      <UtilityMenu />
      <SingleButtonScrollable>
        <CategorizeDowntime history={history} machine={machine} />
      </SingleButtonScrollable>
    </ControlBarResponsive>
  );
};

export { ActiveJobErpDriven };
